import { render, staticRenderFns } from "./StudentTrainAnswerDetail.vue?vue&type=template&id=0d8b8188&scoped=true&"
import script from "./StudentTrainAnswerDetail.vue?vue&type=script&lang=js&"
export * from "./StudentTrainAnswerDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudentTrainAnswerDetail.vue?vue&type=style&index=0&id=0d8b8188&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b8188",
  null
  
)

export default component.exports